import { render, staticRenderFns } from "./SpTabbedPanel.vue?vue&type=template&id=71a80152&scoped=true&"
import script from "./SpTabbedPanel.vue?vue&type=script&lang=js&"
export * from "./SpTabbedPanel.vue?vue&type=script&lang=js&"
import style0 from "./SpTabbedPanel.vue?vue&type=style&index=0&id=71a80152&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71a80152",
  null
  
)

export default component.exports